import React, { FC, isValidElement, PropsWithChildren, ReactElement } from 'react';

import { TabProps } from './tab';
import { StyledContainer, StyledButton, StyledContent, StyledTabs } from './tabs.styled';

interface TabsProps {
    selectedTab: string;
    changeSelectedTab: (key: string) => void;
}

export const Tabs: FC<PropsWithChildren<TabsProps>> = (props) => {
    const { children, selectedTab, changeSelectedTab } = props;

    const renderButton = (tabElement: ReactElement<TabProps>): ReactElement => {
        const tabKey: string = tabElement.props.tabKey;
        const active: boolean = selectedTab === tabKey;

        return (
            <StyledButton
                role="tab"
                aria-selected={active}
                aria-controls={`tabpanel_${tabKey}`}
                key={tabKey}
                id={tabKey}
                onClick={() => changeSelectedTab(tabKey)}
                $active={active}
            >
                <StyledContent>{tabElement.props.title}</StyledContent>
            </StyledButton>
        );
    };

    const renderContent = (content: ReactElement<TabProps>): ReactElement => {
        const tabKey: string = content.props.tabKey;
        const active: boolean = selectedTab === tabKey;

        return (
            <div
                id={`tabpanel_${tabKey}`}
                role="tabpanel"
                aria-labelledby={`tabpanel_${tabKey}`}
                hidden={!active}
                key={tabKey}
            >
                {content}
            </div>
        );
    };

    const filterValidChildren = (): ReactElement<TabProps>[] =>
        React.Children.map(children, (child) => (child && isValidElement<TabProps>(child) ? child : undefined))?.filter(
            Boolean,
        ) || [];

    return (
        <StyledContainer>
            <StyledTabs role="tablist">{filterValidChildren().map(renderButton)}</StyledTabs>
            {filterValidChildren().map(renderContent)}
        </StyledContainer>
    );
};
